import { render, staticRenderFns } from "./LinkedAppsPage.vue?vue&type=template&id=37d543f1&scoped=true&"
import script from "./LinkedAppsPage.vue?vue&type=script&lang=ts&"
export * from "./LinkedAppsPage.vue?vue&type=script&lang=ts&"
import style0 from "./LinkedAppsPage.vue?vue&type=style&index=0&id=37d543f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d543f1",
  null
  
)

export default component.exports